
import { lazy, Suspense } from 'react';

// Only the homepage is eagerly loaded for fastest initial paint
import IndexPage from '@/pages/Index';

// Lazy load ALL other pages to reduce initial JS bundle
const CoachingPage = lazy(() => import('@/pages/Coaching'));
const ConsultingPage = lazy(() => import('@/pages/Consulting'));
const ExecutiveCoachingPage = lazy(() => import('@/pages/ExecutiveCoaching'));
const OutdoorCoachingPage = lazy(() => import('@/pages/OutdoorCoaching'));
const FinanzcoachingPage = lazy(() => import('@/pages/Finanzcoaching'));
const CoachingNuernbergPage = lazy(() => import('@/pages/CoachingNuernberg'));
const PreisePage = lazy(() => import('@/pages/Preise'));
const PaketinfoPage = lazy(() => import('@/pages/Paketinfo'));
const UeberMichPage = lazy(() => import('@/pages/UeberMich'));
const KontaktPage = lazy(() => import('@/pages/Kontakt'));
const DankePage = lazy(() => import('@/pages/Danke'));
const ImpressumPage = lazy(() => import('@/pages/Impressum'));
const DatenschutzPage = lazy(() => import('@/pages/Datenschutz'));
const AGBPage = lazy(() => import('@/pages/AGB'));
const MustervertragVerbraucherPage = lazy(() => import('@/pages/MustervertragVerbraucher'));
const MustervertragUnternehmerPage = lazy(() => import('@/pages/MustervertragUnternehmer'));
const FAQPage = lazy(() => import('@/pages/FAQ'));
const RechtlicherHinweisPage = lazy(() => import('@/pages/RechtlicherHinweis'));

const NotFound = lazy(() => import('@/pages/NotFound'));
const BlogPage = lazy(() => import('@/pages/Blog'));
const BlogPost = lazy(() => import('@/pages/BlogPost'));

// Suspense wrapper for lazy-loaded pages
const LazyPage = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-pulse flex flex-col items-center">
        <div className="h-12 w-12 bg-joerg-500/20 rounded-full"></div>
        <div className="mt-4 text-joerg-600">Wird geladen...</div>
      </div>
    </div>
  }>
    {children}
  </Suspense>
);

// Define main routes - only IndexPage is eagerly loaded
const mainRoutes = [
  { path: "/", element: <IndexPage /> },
  { path: "/coaching", element: <LazyPage><CoachingPage /></LazyPage> },
  { path: "/consulting", element: <LazyPage><ConsultingPage /></LazyPage> },
  { path: "/executive-coaching", element: <LazyPage><ExecutiveCoachingPage /></LazyPage> },
  { path: "/outdoor-coaching", element: <LazyPage><OutdoorCoachingPage /></LazyPage> },
  { path: "/finanzcoaching", element: <LazyPage><FinanzcoachingPage /></LazyPage> },
  { path: "/coaching-nuernberg", element: <LazyPage><CoachingNuernbergPage /></LazyPage> },
  
  { path: "/preise", element: <LazyPage><PreisePage /></LazyPage> },
  { path: "/paketinfo", element: <LazyPage><PaketinfoPage /></LazyPage> },
  { path: "/ueber-mich", element: <LazyPage><UeberMichPage /></LazyPage> },
  { path: "/faq", element: <LazyPage><FAQPage /></LazyPage> },
  
  { path: "/blog", element: <LazyPage><BlogPage /></LazyPage> },
  { path: "/blog/:slug", element: <LazyPage><BlogPost /></LazyPage> },
  { path: "/kontakt", element: <LazyPage><KontaktPage /></LazyPage> },
  { path: "/danke", element: <LazyPage><DankePage /></LazyPage> },
  { path: "/impressum", element: <LazyPage><ImpressumPage /></LazyPage> },
  { path: "/datenschutz", element: <LazyPage><DatenschutzPage /></LazyPage> },
  { path: "/agb", element: <LazyPage><AGBPage /></LazyPage> },
  { path: "/mustervertrag-verbraucher", element: <LazyPage><MustervertragVerbraucherPage /></LazyPage> },
  { path: "/mustervertrag-unternehmer", element: <LazyPage><MustervertragUnternehmerPage /></LazyPage> },
  { path: "/rechtlicher-hinweis", element: <LazyPage><RechtlicherHinweisPage /></LazyPage> },
  
  { path: "*", element: <LazyPage><NotFound /></LazyPage> }
];

export default mainRoutes;
